<template>
    <!--Modal para mostrar mensaje confirmar eliminar -->
    <v-dialog
        v-model="dialogAlert"
        persistent
        max-width="290"
    >
        <v-card>
            <v-card-title class="headline" />
            <v-card-text>

                       <v-row >
                    <v-col cols="2">
                        <v-icon
                            x-large
                            :color="color"
                        >
                            {{ icon }}
                        </v-icon>
                    </v-col>
                    <v-col cols="10">
                        {{ msjDialog }}
                    </v-col>
                </v-row>

                
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <div v-if="isDelete">
                    <v-btn
                        color="default darken-1"
                        text
                        @click="salirDialog()"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="red darken-1"
                        text
                        @click="deleteElement()"
                    >
                        Eliminar
                    </v-btn>
                </div>
                <!-- <div v-else-if="isUpdate">
                        <v-btn
                            color="green darken-1"
                            text
                            @click="dialogConfirm = false"
                        >
                            Aceptar
                        </v-btn>
        </div>-->
                <div v-else>
                    <v-btn
                        :color="colorButton"
                        text
                        @click="closeDialogConfir"
                    >
                        Aceptar
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "ModalMsjConfirm",
  props: {
    tipoMsj: {
      type: Number,
      required: true
    },
    msjDialog: {
      type: String,
      required: true
    },
 
    closeDialogConfir: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      dialogAlert: false,
      isDelete: false,
      isUpdate: false,
      color: "",
      icon: "",
      colorButton: ""
    };
  },
  watch: {
    tipoMsj: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        console.log("Old: " + oldValue + " - New: " + newValue);
        switch (newValue) {
          case 1: //dialog info
            this.isDelete = false;
            this.isUpdate = false;
            this.dialogAlert = true;

            this.color = "blue darken-2"
             this.colorButton = "green darken-1"
            this.icon = "mdi-info-circle"
            break;
          case 2: //dialog error
            this.isDelete = false;
            this.isUpdate = false;
            this.dialogAlert = true;

            this.color = "error"
            this.colorButton = "red darken-1"
            this.icon = "mdi-alert-octagon"
            break;
          case 3: //dialog delete
            this.isDelete = true;
            this.isUpdate = false;
            this.dialogAlert = true;
            this.color = "orange darken-2"
            this.icon = "mdi-alert-decagram"
            break;
          case 4: //dialog success
            this.isDelete = false;
            this.isUpdate = false;
            this.dialogAlert = true;

            this.color = "blue darken-2"
            this.colorButton = "green darken-1"
            this.icon = "mdi-check-all"
            break;
            default:
            this.isDelete = false;
            this.isUpdate = false;
            this.dialogAlert = false;
                break
        }
      }
    }
  },
  mounted() {},
  methods: {
    deleteElement() {
     // this.dialog = false;
      this.$emit("delete-element", true);
      this.$emit("show-dialog", 0);
    },
    salirDialog() {
      //this.showDialog = false;
      this.$emit("show-dialog", 0);
    }
  }
};
</script>

<style>
</style>